// atoms/hideSearchAtom.ts
import { atom } from 'jotai';

export const hideSearchAtom = atom<boolean>(false);
